import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HomeBuildingState } from './home-building.reducer';

// Select the feature slice
export const selectHomeBuildingState = createFeatureSelector<HomeBuildingState>('homeBuildingReducer');

// Select properties from the feature slice
export const selectProjects = createSelector(selectHomeBuildingState, state => state?.projects ?? []);

export const selectLots = createSelector(selectHomeBuildingState, state => state?.lots ?? []);

export const selectSelectedProject = createSelector(selectHomeBuildingState, state => state?.projectId);

// Selector to get lots for selected projectId
export const selectProjectLots = createSelector(selectHomeBuildingState, selectSelectedProject, (state, projectId) => {
  if (!state || !projectId || !state.projectLots || !state.projectLots[projectId]) {
    return [];
  }
  return state.projectLots[projectId];
});

export const selectCities = createSelector(selectHomeBuildingState, state => state?.cities ?? []);

export const selectProductList = createSelector(selectHomeBuildingState, state => state?.productList ?? []);

export const selectCategoryListByProductListId = (productListId: string) =>
  createSelector(selectHomeBuildingState, state => state?.categoryListByProductListId?.[productListId] || []);

export const selectCategoryList = createSelector(selectHomeBuildingState, state => state?.categoryList ?? []);

export const selectSubcategories = (categoryListId: string) =>
  createSelector(selectHomeBuildingState, state => state?.subcategories?.[categoryListId] || []);

export const selectUofms = createSelector(selectHomeBuildingState, state => state?.uofms ?? []);

export const selectProjectLocations = createSelector(selectHomeBuildingState, state => state?.locations ?? []);

export const selectCountries = createSelector(selectHomeBuildingState, state => state?.countries ?? []);

export const selectCitiesByCountryId = () =>
  createSelector(selectHomeBuildingState, state => state?.citiesByCountryId ?? []);

export const selectTemplateTypes = createSelector(
  selectHomeBuildingState,
  state => state?.templateVariablesTypes ?? []
);
